<template lang="pug">
    m-accordion-primary(class="m-accordion-risk-assessment")
        template
            m-accordion-content(v-for="(section, key) in configuration"
                :key="`section-${key}`")
                template(#header="")
                    v-layout(col wrap align-center class="m-accordion-risk-assessment__header" attach="#sectionAnchor")
                        v-flex(sm12)
                            component(:is="accordionIcons[key]" @click.native.stop="openIconInfoDialog" v-if="accordionIcons[key]" class="m-accordion-risk-assessment__icon-header")
                            | {{section.title}}

                v-flex(xs12 class="pt-4")
                    v-layout(wrap v-for="(question, questionKey) in section.children" :class="rowClass(question)" class="m-accordion-risk-assessment__body" tabindex="0")
                        v-flex(:key="`section-${key}-${questionKey}`"
                            class="px-0"
                            xs12)

                            e-typography-body-small(v-if="!isCollapsible(question)" tabindex="0" class="e-typography-body" @click="toAssessment(key, questionKey)" @keyup.enter="toAssessment(key, questionKey)")
                                e-typography-links-small(
                                    style="cursor:pointer"
                                    class="m-accordion-risk-assessment__item"
                                    @click="toAssessment(key, questionKey)"
                                    id="sectionAnchor")
                                    component(:is="questionsIcons[key][questionKey]" v-if="questionsIcons[key][questionKey]" @click.native.stop="openIconInfoDialog" class="m-accordion-risk-assessment__icon")
                                    | {{question.title}}

                            m-accordion-primary(v-else class="m-accordion-risk-assessment__sub-accordion")
                                m-accordion-content( )
                                    template(#header="")
                                        v-flex( class="px-0 pt-2 pb-2 pl-2" xs12)
                                            e-typography-body-small(class="m-accordion-risk-assessment__sub-accordion__item" attach="#section2Anchor" @click.native.stop="toAssessment(key, questionKey)")
                                                component(:is="questionsIcons[key][questionKey]" v-if="questionsIcons[key][questionKey]" @click.native.stop="openIconInfoDialog" class="m-accordion-risk-assessment__icon")
                                                | {{question.title}}
                                    m-list-effectiveness-option(
                                        :items="getOptionsChildren(question)"
                                        :answers="answers"
                                        :main-section-key="key"
                                        :section-key="questionKey"
                                        @click:option-question="toOptionQuestionAssessment($event, key, questionKey)"
                                        @keyup.enter="toOptionQuestionAssessment($event, key, questionKey)"
                                        class="m-accordion-risk-assessment__sub-accordion__list"
                                    )


                v-layout(justify-end class="my-4" class="m-accordion-risk-assessment__action")
                    v-flex(shrink)
                        e-button-primary(@click="toAssessment(key)" class="ma-0")
                            | {{$t('modules.accordions.m-accordion-risk-assessment.sectionButton')}}

</template>

<script>
    import {questions} from "@constants/common";
    import assessment from "@mixins/helpers/_assessment";

    import MAccordionPrimary from "@modules/accordions/types/m-accordion-primary";
    import MAccordionContent from "@modules/accordions/includes/_m-accordion-content";

    import MListEffectivenessOption from '@modules/lists/concrete/m-list-effectiveness-option';
    import statusIconDialog from "@mixins/additional/_statusIconDialog";

    let name = 'm-accordion-risk-assessment';
    export default {
        // TODO this functionality will be refactored and rethink after API implementation of effectiveness check
        name: name,
        components: {MAccordionContent, MAccordionPrimary, MListEffectivenessOption},
        mixins: [assessment, statusIconDialog],
        props: {
            name: {
                type: String,
                default: name
            },
            configuration: {
                type: Array,
                required: true
            },
            answers: {
                type: Array,
                required: true
            },
            isOnboarding: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            answerList() {
                return this.answers
            },
            questionsIcons() {
                let result = [];
                this.answerList.forEach(sectionAnswers => {
                    let items = [];
                    if (!!sectionAnswers.children) {
                        sectionAnswers.children.forEach(questionAnswers => {
                            items.push(this.assessmentHelper.questionIcon(questionAnswers))
                        });
                    }
                    result.push(items);
                });
                return result;
            },
            accordionIcons() {
                let result = [];
                this.questionsIcons.forEach((questionsIcons) => {
                    result.push(this.assessmentHelper.sectionIcon(questionsIcons))
                });
                return result;
            }

        },
        methods: {
            rowClass(q) {
                return [
                    !this.isCollapsible(q) ? `${name}__row` : null
                ]
            },

            isCollapsible(question) {
                return !!(question.children && question.children[0].type == questions.types.options)
            },

            getOptionsChildren(question) {
                if (typeof question.children === "undefined") {
                    return [];
                }

                if (typeof question.children[0] === "undefined") {
                    return [];
                }

                if (typeof question.children[0].children === "undefined") {
                    return [];
                }

                return question.children[0].children;
            },

            toAssessment(sectionKey, questionKey) {
                let query = [
                    sectionKey,
                ];

                if (this.$lodash.isNumber(questionKey)) {
                    query[1] = questionKey;
                }
                query = query.join('-')
                if (this.isOnboarding) {
                    this.redirect(this.nav.dashboard.service.onboarding_risk_assessment.process.name, {
                        id: this.$route.params.id
                    }, {level: query});
                } else {
                    this.redirect(this.nav.dashboard.service.risk_assessment.process.name, {
                        id: this.$route.params.id
                    }, {level: query});
                }
            },
            toOptionQuestionAssessment(payload, mainSectionKey, optionKey) {
                let query = `${mainSectionKey}-${optionKey}-0-${payload.optionSectionKey}-${payload.questionKey}`
                if (this.isOnboarding) {
                    // this.redirect(this.nav.dashboard.service.onboarding_risk_assessment.process.name, {
                    //     id: this.$route.params.id
                    // }, {level: query, once: 'yes'});
                } else {
                    this.redirect(this.nav.dashboard.service.risk_assessment.process.name, {
                        id: this.$route.params.id
                    }, {level: query, once: 'yes'});
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .m-accordion-risk-assessment {

        /deep/ &__item {
            position: relative;
            display: inline-block;
            font-weight: normal;
            outline: none;

            &:focus {
                border-bottom: 2px solid var(--v-primary-base);
            }

            @include updatedMedia(sm) {
                margin-left: 0px;
                display: flex;
            }
        }

        /deep/ &__icon {
            margin-right: 1rem;

            @include updatedMedia(sm) {
                position: relative;
                top: 2px;
            }
        }

        &__icon-header {
            margin-right: 1rem;
        }

        /deep/ &__row {

            &:focus {
                border-bottom: 2px solid var(--v-primary-base);
                outline: none;
            }

            .flex {
                padding: 0;
            }
        }

        /deep/ &__row:last-child {
            border-bottom: 0px !important;
        }

        /deep/ &__section {
            &:hover {
                background-color: var(--v-secondary-darken1);
            }

            &:last-of-type {
                border-bottom: 1px solid black;
            }
        }

        &__sub-accordion {
            .v-expansion-panel {
                &__container {
                    box-shadow: none !important;
                }
            }
        }

        /deep/ .v-expansion-panel {
            &__container {
                height: auto;
                padding: 1rem !important;
                box-shadow: 0px 0px 4px 0px rgba(0, 73, 148, 0.61);
                margin-bottom: 1rem;
                border-radius: 3px;
                border-top: none !important;

                &:focus {
                    border-bottom: 2px solid var(--v-primary-base);
                }
            }

            &__header {
                min-height: auto;

                @include updatedMedia(sm) {
                    margin-left: 0px !important;
                }
            }
        }

        &__action {
            margin-top: 0.5rem !important;
            margin-bottom: 0.5rem !important;
        }

        &__sub-accordion {
            &__item {
                position: relative;
                display: inline-block;
                cursor: pointer;
                &:hover{
                    color: var(--v-primary-base);
                }
            }

            &__list {
                margin-top: 0 !important;
                margin-bottom: 0 !important;
            }

            /deep/ .v-expansion-panel {
                &__container {
                    padding: 0 !important;
                    margin: 0;
                    background-color: transparent;
                    border-top: none !important;
                    border-bottom: none;
                }

                &__body {
                    padding-top: 0rem !important;
                    outline: none;
                    padding-left: .5rem;

                    /deep/ hr {
                        display: none !important;
                    }

                    &:focus {
                        border-bottom: 2px solid var(--v-primary-base);
                    }
                }
            }
        }

        .e-typography-body {
            border-bottom: 1px solid var(--v-secondary-base);
            outline: none;
            padding: .5rem;

            &:focus {
                border-bottom: 2px solid var(--v-primary-base);
            }

            &:hover {
                background-color: var(--v-secondary-darken1);
            }
        }
    }
</style>
